import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldCheck2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShieldCheck2"><Path d="M9.5 12.25L11 13.75L14.5 10.25M3.5 3.50006H20.5V18L12 22.5001L3.5 18V3.50006Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShieldCheck2;
